import { useState, useEffect } from 'react'
import { Checkbox, Tooltip } from '@mantine/core'

import Box from '@/components/ui/Box'

const CHANNELS = [
    { key: 'in_app', label: 'In-app' },
    { key: 'email', label: 'Email' },
    { key: 'slack', label: 'Slack', disabled: true },
]

export default function NotificationPreferences({ preferences, baseUrl, requestPost }) {
    const [prefs, setPrefs] = useState(preferences)

    useEffect(() => {
        setPrefs(preferences)
    }, [preferences])

    const toggle = async (type, channel, checked) => {
        // Optimistic update
        setPrefs((prev) =>
            prev.map((p) => (p.type === type ? { ...p, [channel]: checked } : p))
        )

        try {
            await requestPost(`${baseUrl}/notification-preferences`, {
                type,
                channel,
                enabled: checked,
            })
        } catch {
            // Rollback on error
            setPrefs((prev) =>
                prev.map((p) => (p.type === type ? { ...p, [channel]: !checked } : p))
            )
        }
    }

    return (
        <Box title="Notifications">
            <div className="flex flex-col">
                {/* Header */}
                <div className="flex items-center gap-2 pb-2 mb-2 border-b border-gray-100">
                    <div className="flex-1" />
                    {CHANNELS.map((ch) => (
                        <div
                            key={ch.key}
                            className="w-16 text-center text-xs font-medium text-gray-400"
                        >
                            {ch.label}
                        </div>
                    ))}
                </div>

                {/* Rows */}
                {prefs.map((pref) => (
                    <div
                        key={pref.type}
                        className="flex items-center gap-2 py-2"
                    >
                        <span className="flex-1 text-sm">{pref.label}</span>
                        {CHANNELS.map((ch) => (
                            <div key={ch.key} className="w-16 flex justify-center">
                                {ch.disabled ? (
                                    <Tooltip label="Bientôt disponible" withArrow position="top">
                                        <div>
                                            <Checkbox
                                                checked={false}
                                                disabled
                                                size="sm"
                                            />
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <Checkbox
                                        checked={pref[ch.key] ?? false}
                                        onChange={(e) => toggle(pref.type, ch.key, e.currentTarget.checked)}
                                        size="sm"
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </Box>
    )
}
